var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.keyy === 0)?_c('div',{staticClass:"streamify-video"},[_c('video',{ref:"video",staticClass:"video-js",attrs:{"playsinline":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }